import { gql } from 'graphql-request';

export type {
    PolygonTag,
    PolygonTags,
    GetSitePolygons,
    AddPolygonTagInput,
    AddPolygonTagResult,
    DeletePolygonTagInput,
    DeletePolygonTagResult,
} from 'src/shared/types/graph';

export const getSitesWithTagsQuery = gql`
    query GetSitesWithTags($projectId: String!) {
        admin {
            sites(projectId: $projectId) {
                properties {
                    name
                    tags {
                        name
                        value
                    }
                }
            }
        }
    }
`;

export const addPolygonLevelTagMutation = gql`
    mutation AddAssetTag($input: AddAssetTagInput!) {
        admin {
            addAssetTag(input: $input)
        }
    }
`;

export const deletePolygonLevelTagMutation = gql`
    mutation DeleteAssetTag($input: DeleteAssetTagInput!) {
        admin {
            deleteAssetTag(input: $input)
        }
    }
`;

export const renamePolygonMutation = gql`
    mutation RenameAsset($input: RenameAssetInput!) {
        admin {
            renameAsset(input: $input)
        }
    }
`;
